const designButton = document.querySelector('#customers_canvas_button');
designButton.addEventListener('click', function () {
  let selectedVariantId = getSelectedVariantId();
  let quantity = getQuantity();
  let sku = getSelectedSku();

  const url = new URL(window.location.origin);

  url.searchParams.set('view', 'customers-canvas-he');
  url.searchParams.set('variant', selectedVariantId);
  url.searchParams.set('quantity', quantity);
  url.searchParams.set('sku', sku);

  window.location.search = url.search;

  function getSelectedVariantId() {
    const _getFromForm = () => {
      const formElement = document.querySelector("form[action='/cart/add']");
      const formString = new URLSearchParams(new FormData(formElement)).toString();
      if (formString) {
        const urlSearchParams = new URLSearchParams(formString);
        const objData = Object.fromEntries(urlSearchParams.entries());
        if (objData && objData['id']) {
          return objData['id'];
        } else {
          return null;
        }
      } else {
        return null;
      }
    };
    const _getFromShopifyMeta = () => {
      return window.ShopifyAnalytics?.meta?.selectedVariantId || null;
    }
    const selectedVariantId = _getFromForm() || _getFromShopifyMeta();
    return selectedVariantId == null ? selectedVariantId : Number(selectedVariantId);
  };

  function getSelectedSku() {
    const skuElement = document.querySelector('.product__sku[role="status"]');
    const skuElementContentArray = skuElement.innerHTML.split('</span>');
    const rawSku = (skuElementContentArray?.length > 1) ? skuElementContentArray[skuElementContentArray.length-1] : skuElementContentArray[0];
    const sku = rawSku.replace('&nbsp;', '');
    return sku;
  }

  function getQuantity() {
    var qty = document.querySelector(".quantity__input")?.value;
    if (!qty) {
      qty = 1;
    }
    return qty;
  }
});